/**
 * @file This package is a wrapper around `fraction.js/bigfraction` as that doesn't have type
 * annotations.
 */
/** @inheritdoc */
// @ts-expect-error This is not typed.
import Fraction from 'fraction.js/bigfraction';
/** @inheritdoc */
export { Fraction };
/** Constant fraction representing 0. */
export const ZERO = new Fraction(0);
/** Constant fraction representing 1. */
export const ONE = new Fraction(1);
/**
 * Check if a fraction is zero.
 *
 * @param frac The fraction to check.
 * @returns If the fraction is zero.
 */
export function isZero(frac) {
    return frac.compare(ZERO) === 0;
}
/**
 * Checks if a fraction is negative.
 *
 * @param frac The fraction.
 * @returns Whether the fraction is negative.
 */
export function isNegative(frac) {
    return frac.compare(ZERO) < 0;
}
